import React from 'react';
import {LEAN_BLOCKS} from './constants';
import {Glyphicon} from 'react-bootstrap';

function LeanBlockIcon({block}) {
    let iconClassName = '';

    switch (block) {
        case LEAN_BLOCKS.LEARN:
            iconClassName = 'edit';
            break;
        case LEAN_BLOCKS.MEASURE:
            iconClassName = 'dashboard';
            break;
        case LEAN_BLOCKS.BUILD:
            iconClassName = 'wrench';
            break;
        default:
            break;
    }

    return (
        <Glyphicon glyph={iconClassName} aria-hidden="true"/>
    );
}

export default(LeanBlockIcon);